var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfileRebate1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_96295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1570_96295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1570_96295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1570_96295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1570_96295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04667 10.2684C6.53402 10.269 7.02088 10.2378 7.50417 10.1751V5.10506C7.02088 5.04232 6.53402 5.01114 6.04667 5.01173C3.15917 5.01173 0.817505 6.07339 0.817505 7.38339V7.89756C0.817505 9.20673 3.15917 10.2684 6.04667 10.2684Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04669 12.9177C6.53404 12.9183 7.0209 12.8871 7.50419 12.8244V11.3385C7.02092 11.4016 6.53406 11.433 6.04669 11.4327C3.52586 11.4327 1.42253 10.6235 0.92836 9.54688C0.856843 9.69891 0.819306 9.8647 0.81836 10.0327V10.5469C0.817526 11.856 3.15919 12.9177 6.04669 12.9177Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50419 14.1009V13.985C7.02092 14.0481 6.53406 14.0795 6.04669 14.0792C3.52586 14.0792 1.42253 13.27 0.928359 12.1934C0.856817 12.3454 0.819279 12.5112 0.818359 12.6792V13.1934C0.818359 14.5034 3.15919 15.565 6.04669 15.565C6.59977 15.566 7.15214 15.5256 7.69919 15.4442C7.5713 15.1865 7.50457 14.9027 7.50419 14.615V14.1009Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.585 4.33008C10.6975 4.33008 8.35669 5.39174 8.35669 6.70175V7.21591C8.35669 8.52591 10.6975 9.58758 13.585 9.58758C16.4725 9.58758 18.8134 8.52591 18.8134 7.21591V6.70175C18.8134 5.39174 16.4725 4.33008 13.585 4.33008Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.585 10.7491C11.0642 10.7491 8.96086 9.93995 8.46669 8.86328C8.39515 9.01531 8.35761 9.1811 8.35669 9.34911V9.86328C8.35669 11.1733 10.6975 12.2349 13.585 12.2349C16.4725 12.2349 18.8134 11.1733 18.8134 9.86328V9.34911C18.8124 9.1811 18.7749 9.01531 18.7034 8.86328C18.2092 9.93995 16.1059 10.7491 13.585 10.7491Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.585 13.3976C11.0642 13.3976 8.96086 12.5884 8.46669 11.5117C8.39515 11.6637 8.35761 11.8295 8.35669 11.9976V12.5117C8.35669 13.8217 10.6975 14.8834 13.585 14.8834C16.4725 14.8834 18.8134 13.8217 18.8134 12.5117V11.9976C18.8124 11.8295 18.7749 11.6637 18.7034 11.5117C18.2092 12.5884 16.1059 13.3976 13.585 13.3976Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.585 16.1866C11.0642 16.1866 8.96086 15.3774 8.46669 14.3008C8.39515 14.4528 8.35761 14.6186 8.35669 14.7866V15.3008C8.35669 16.6108 10.6975 17.6724 13.585 17.6724C16.4725 17.6724 18.8134 16.6108 18.8134 15.3008V14.7866C18.8124 14.6186 18.7749 14.4528 18.7034 14.3008C18.2092 15.3774 16.1059 16.1866 13.585 16.1866Z",
    fill: "#9196AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_96295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileRebate1);
export default __webpack_public_path__ + "static/media/icon-profile-rebate_1.09abe0cef5fefefd87f890d7cab2c128.svg";
export { ForwardRef as ReactComponent };